import { Dropdown, DropdownProps } from 'antd';
import { useLogout } from '../../hooks/useLogout';
import { AvatarWithLabelWrapper, StyledAvatar, Text } from '@ydistri/ds';
import { wordInitials } from '../../helpers/wordInitials';
import React, { useMemo } from 'react';
import { icons, IconType } from '../icons/icons';
import { RoutingPage } from '../../routes/routerSlice';
import { Link } from 'react-router';
import { useSider } from '../../hooks/useSider';
import { useUser } from '../../hooks/useUser';
import { FiChevronDown } from 'react-icons/fi';
import { ItemType } from 'antd/es/menu/interface';
import { useStableParams } from '../../routes/useStableParams';
import { computeRemSize } from '@ydistri/theme';

const dropdownTriggers: DropdownProps['trigger'] = ['click'];
const dropdownOverlayStyle = { width: computeRemSize(200) };
const dropdownAlign: DropdownProps['align'] = { offset: [0, 10] };

const UserMenu: React.FC = () => {
  const { isLeftMenuCollapsed } = useSider();
  const params = useStableParams();
  const projectShortName = params.projectShortName;
  const user = useUser();
  const logout = useLogout();

  const userOptionDropdownItems: ItemType[] = useMemo(
    () =>
      projectShortName !== undefined
        ? [
            {
              label: <Link to={`/${projectShortName}/${RoutingPage.USER_SETTINGS}`}>Settings</Link>,
              key: '1',
              icon: icons[IconType.SETTING_OUTLINED],
            },
            {
              type: 'divider',
            },
            {
              label: 'Logout',
              key: '3',
              icon: icons[IconType.LOGOUT_OUTLINED],
              onClick: logout,
            },
          ]
        : [],
    [projectShortName, logout],
  );

  const dropdownMenu = useMemo(
    () => ({ items: userOptionDropdownItems }),
    [userOptionDropdownItems],
  );

  return (
    <Dropdown
      trigger={dropdownTriggers}
      menu={dropdownMenu}
      overlayStyle={dropdownOverlayStyle}
      align={dropdownAlign}
    >
      {user && (
        <AvatarWithLabelWrapper>
          <StyledAvatar>{wordInitials(user.fullName)}</StyledAvatar>
          {isLeftMenuCollapsed ? null : <Text $size="large">{user.fullName}</Text>}
          <FiChevronDown size={computeRemSize(20)} />
        </AvatarWithLabelWrapper>
      )}
    </Dropdown>
  );
};

export default UserMenu;
